// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","clickable":"FypLVg","clickable_link":"ksLl7M","AniFadeIn":"Z93Uto","AniFadeOut":"AqqDwG","AniRotate":"vOgYFZ","AniPlaceholderFadeOut":"ZdP2mI"};